import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';

/** "Reset to my defaults": puts a view's remembered filters back to the app's standard ones. */
export const ResetFiltersButton = ({ onClick, testId, className = '' }) => {
  const { t } = useTranslation();
  return (
    <Button variant="ghost" size="sm" onClick={onClick} data-testid={testId}
      title={t('budget.resetToDefaultsHint')}
      className={`h-8 px-2 text-slate-600 hover:text-slate-900 ${className}`}>
      <RotateCcw className="h-3.5 w-3.5 mr-1" />{t('budget.resetToDefaults')}
    </Button>
  );
};

export default ResetFiltersButton;
